import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SubscribeRidehailsForMovesSubscriptionVariables = Types.Exact<{
  move_ids: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
}>;


export type SubscribeRidehailsForMovesSubscription = { __typename?: 'subscription_root', ridehails: Array<{ __typename?: 'ridehails', id: number, move_id?: number | null, provider?: string | null, status?: string | null, external_id?: string | null, product_type?: string | null, created_at: string }> };


export const SubscribeRidehailsForMovesDocument = gql`
    subscription SubscribeRidehailsForMoves($move_ids: [bigint!]!) {
  ridehails(where: {move_id: {_in: $move_ids}}, order_by: {created_at: desc}) {
    id
    move_id
    provider
    status
    external_id
    product_type
    created_at
  }
}
    `;

/**
 * __useSubscribeRidehailsForMovesSubscription__
 *
 * To run a query within a React component, call `useSubscribeRidehailsForMovesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeRidehailsForMovesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeRidehailsForMovesSubscription({
 *   variables: {
 *      move_ids: // value for 'move_ids'
 *   },
 * });
 */
export function useSubscribeRidehailsForMovesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeRidehailsForMovesSubscription, SubscribeRidehailsForMovesSubscriptionVariables> & ({ variables: SubscribeRidehailsForMovesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeRidehailsForMovesSubscription, SubscribeRidehailsForMovesSubscriptionVariables>(SubscribeRidehailsForMovesDocument, options);
      }
export type SubscribeRidehailsForMovesSubscriptionHookResult = ReturnType<typeof useSubscribeRidehailsForMovesSubscription>;
export type SubscribeRidehailsForMovesSubscriptionResult = Apollo.SubscriptionResult<SubscribeRidehailsForMovesSubscription>;